import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { registerLicense } from '@syncfusion/ej2-base';

// Components
import Navigation from './components/Navigation';
import HomePage from './components/HomePage';
import ImageEditor from './components/ImageEditor';
import BatchResizer from './components/BatchResizer';
import SVGTools from './components/SVGTools';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXleeHVQQmhfV0dxWEVWYUA=');

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-gray-900">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/image-editor" element={<ImageEditor />} />
          <Route path="/batch-resizer" element={<BatchResizer />} />
          <Route path="/svg-tools" element={<SVGTools />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
